import API from "../../core/apiConfig";
import {
  downloadBlobResponse,
  handleBlobExportError,
} from "../../core/download";
import { withRowKeys } from "../../core/response";
import type { CommonRequestOptions, CommonSearchParams } from "./types";

type RegionSearchItem = {
  _id: string;
  name: string;
  pName: string;
};

const getSearchRegion = async (params: CommonSearchParams) => {
  const response = await API.get("admin/regions/search", {
    params,
    silentLoading: true,
  }).then((res) => res.data);

  if (response.success) {
    const data = withRowKeys<RegionSearchItem>(response.data).map((item) => ({
      ...item,
      value: item._id,
      label: `${item.name} - ${item.pName}`,
    }));
    return { data };
  }
};

const getSearchProvine = async (
  params: CommonSearchParams,
  options?: CommonRequestOptions,
) => {
  const response = await API.get(
    `admin/regions/province?searchText=${params.searchText}`,
    {
      params,
      silentLoading: options?.silentLoading ?? false,
    },
  ).then((res) => res.data);

  if (response.success) return { data: withRowKeys(response.data) };
};

const getDownloadTemplate = async (type: string, name: string) => {
  try {
    const response = await API.get(`/import/sample/download?type=${type}`, {
      responseType: "blob",
      silent: true,
      silentLoading: true,
    });

    return downloadBlobResponse(response, name);
  } catch (error: unknown) {
    await handleBlobExportError(error);
    throw error;
  }
};

export default { getSearchProvine, getSearchRegion, getDownloadTemplate };
